import React, { Fragment, useState } from 'react';
import { PageTitle } from '../../../components/PageTitle';
import { useTranslation } from 'react-i18next';

import { useLocation, useNavigate } from 'react-router';
import { ManagedDataTable } from '../../../components/ManagedDataTable';
import {
  useGetContacts,
  useGetJobFunctionsList,
} from '../../../reactQuery/contacts';
import {
  ColumnFilters,
  IManagedDataTable,
} from '../../../components/ManagedDataTable/interfaces';
import { columns } from './helpers';
import { Contact } from '../../../api/contactsApi/interfaces';
import { FloatingActionsButtons } from '../../../components/FloatingActionsButtons';
import { CreateAction } from '../../../components/FloatingActionsButtons/components/CreateAction';
import { UpsertContactDialog } from '../dialogs/UpsertContactDialog';
import { DATA_TABLE_STORAGE_KEYS } from '../../../constants';
import { ROUTES } from '../../../routes/Routes';
import { useGetAgentsList } from '../../../reactQuery/Agents/agents';
import { useGetClientsList } from '../../../reactQuery/clients';

export const ContactsOverview: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [showCreateDialog, setShowCreateDialog] = useState<boolean>(false);

  const { data: agentsList } = useGetAgentsList();
  const { data: clientsList } = useGetClientsList();
  const { data: jobFunctionsList } = useGetJobFunctionsList();

  const onRowClick = (row: Contact): void => {
    navigate(ROUTES.contacts.details(row.id), { state: { from: location } });
  };

  const columnFilters: ColumnFilters = [
    {
      column: 'createdBy',
      label: t('entities:common.createdBy'),
      type: 'multivalue',
      options:
        agentsList?.map((agent) => {
          return {
            id: agent.id,
            name: `${agent.firstName} ${agent.lastName}`,
          };
        }) || [],
    },
    {
      column: 'clients',
      label: t('entities:contact.clients'),
      type: 'multivalue',
      options: clientsList || [],
    },
    {
      column: 'jobFunctions',
      label: t('entities:contact.job_functions'),
      type: 'multivalue',
      options: jobFunctionsList || [],
    },
  ];

  return (
    <Fragment>
      <PageTitle
        title={t('contacts:title')}
        subTitle={t('contacts:subTitle')}
        space
      />
      <ManagedDataTable
        query={useGetContacts as IManagedDataTable<Contact>['query']}
        columns={columns}
        onRowClick={onRowClick}
        storageKey={DATA_TABLE_STORAGE_KEYS.contacts}
        initialSort={{ field: 'lastName', sort: 'asc' }}
        columnFilters={columnFilters}
      />

      <UpsertContactDialog
        show={showCreateDialog}
        onClose={() => setShowCreateDialog(false)}
      />

      <FloatingActionsButtons>
        <CreateAction onClick={() => setShowCreateDialog(true)} />
      </FloatingActionsButtons>
    </Fragment>
  );
};
